module.exports = __webpack_public_path__ + "static/media/info.65e1df21.svg";